import { Box, styled } from '@mui/material';
import { AndBlockViewer } from './and-block-viewer';
import { OrBlockValues } from '../../../workflow-sidebar/edit-node-form/nodes/enroll-node-editor/enroll-node-editor.types';

type OrBlockViewerProps = {
  orBlocks: OrBlockValues[];
  isExpanded: boolean;
};

export const OrBlockViewer = ({ orBlocks, isExpanded }: OrBlockViewerProps) => {
  if (!orBlocks || orBlocks.length === 0) {
    return null;
  }

  return (
    <EnrollNodeConditionsBox expanded={isExpanded}>
      {orBlocks.map((block, index) => (
        <Box key={index}>
          <AndBlockWrapper>
            {block.andBlocks.map((andBlock, andIndex) => (
              <AndBlockViewer
                key={andIndex}
                andBlock={andBlock}
                isLast={andIndex === block.andBlocks.length - 1}
              />
            ))}
          </AndBlockWrapper>
          {index < orBlocks.length - 1 && <LogicalOperatorWrapper>OR</LogicalOperatorWrapper>}
        </Box>
      ))}
    </EnrollNodeConditionsBox>
  );
};

const EnrollNodeConditionsBox = styled(Box)<{ expanded: boolean }>(({ theme, expanded }) => ({
  marginBottom: expanded ? theme.spacing(5) : theme.spacing(1),
  padding: theme.spacing(2),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(3),
  backgroundColor: theme.palette.grey[100],
}));

const LogicalOperatorWrapper = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  fontSize: '10px',
  color: theme.palette.lwBlack[100],
}));

const AndBlockWrapper = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(3),
  backgroundColor: theme.palette.lwWhite[100],
}));
